import React from "react";

// NOTE: this component relies on styles defined in WebAccess/src/csi/css/styles.styl

export const WaitOverlay = ({ show = false, transparent = false }) => {
	if (!show) return null;
	return (
		<div className={`csi-wait ${transparent ? "csi-wait-transparent" : ""}`}>
			{!transparent && (
				<div className="csi-loading-circles">
					<div className="csi-loading-circle1" />
					<div className="csi-loading-circle2" />
					<div className="csi-loading-circle3" />
					<div className="csi-loading-circle4" />
				</div>
			)}
		</div>
	);
};
